import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-variable-code-block-update',
  templateUrl: './variable-code-block-update.component.html',
  styleUrls: ['./variable-code-block-update.component.scss']
})
export class VariableCodeBlockUpdateComponent implements OnInit {
  variable_code_block_id: any;

  constructor(   private route: ActivatedRoute) { 
    this.variable_code_block_id = +this.route.snapshot.paramMap.get('variable_code_block_id');
  }

  ngOnInit(): void {
  }

}
